import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import HelpSteps, { type Step } from './_HelpSteps'

function DeactivationHelp(): JSX.Element {
  const steps: Step[] = [
    { number: 1, content: i18n.t('personal_settings.mfa.deactivation_help.step_1') },
    { number: 2, content: i18n.t('personal_settings.mfa.deactivation_help.step_2') },
    { number: 3, content: i18n.t('personal_settings.mfa.deactivation_help.step_3') },
  ]

  return <HelpSteps steps={steps} />
}

export default observer(DeactivationHelp)
